// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 7: LISTY I APOKALIPSA
// ============================================================================
// Poziomy 79-91 (13 poziomów, 39 pytań)

export const chapter7Translations = {
  name: "Listy i Apokalipsa",
  description: "Kto zwycięży, odziedziczy to wszystko... Mądrość z góry uświęca rozumienie",
  
  spiritualWisdom: {
    principle: "Mądrość z góry uświęca rozumienie i ożywia ducha",
    scripture: "Jeśli któremuś z was brakuje mądrości, niech prosi Boga (Jakub 1:5)",
    application: "Każdy list apostolski i każde widzenie z Apokalipsy wzbogaca nasze rozumienie i umacnia naszą nadzieję"
  },
  
  levels: {
    79: {
      name: "Aresztowanie w Jerozolimie",
      challenge: "Jestem gotów nie tylko być związany, ale też umrzeć w Jerozolimie...",
      easy: {
        question: "Gdzie został aresztowany Paweł podczas ostatniej wizyty?",
        options: ["Antiochia", "Efez", "Jerozolima", "Korynt"],
        correctAnswer: 2,
        hint: "Święte miasto, które często prześladowało proroków",
        funFact: "🏛️ Jerozolima: miejsce chwały i cierpienia dla wszystkich sług Bożych!"
      },
      medium: {
        question: "O co Żydzi oskarżyli Pawła?",
        options: [
          "Kradzież ze świątyni",
          "Zbezczeszczenie świątyni przez wprowadzenie pogan",
          "Bluźnierstwo przeciw Mojżeszowi",
          "Bunt przeciw Rzymowi"
        ],
        correctAnswer: 1,
        hint: "Oskarżenie związane z uniwersalnością Ewangelii",
        funFact: "⛪ Ironia: Paweł oskarżony o zbezczeszczenie świątyni, którą głęboko szanował!"
      },
      hard: {
        question: "Jak Paweł przekształcił więzienie w szansę?",
        options: [
          "Uciekł",
          "Świadczył przed władzami i pisał swoje listy",
          "Milczał",
          "Negocjował uwolnienie"
        ],
        correctAnswer: 1,
        hint: "Chodzi o przekształcenie próby w świadectwo",
        funFact: "⛓️ Fizyczne kajdany, duchowa wolność - potężne świadectwo wiary!"
      }
    },
    
    80: {
      name: "Przed Namiestnikiem Feliksem",
      challenge: "Gdy mówił o sprawiedliwości, wstrzemięźliwości i przyszłym sądzie...",
      easy: {
        question: "Przed którym namiestnikiem Paweł świadczył o swojej wierze?",
        options: ["Piłat", "Feliks", "Festus", "Gallion"],
        correctAnswer: 1,
        hint: "Namiestnik znany z chciwości",
        funFact: "⚖️ Feliks liczył na łapówkę - korupcja wobec uczciwości!"
      },
      medium: {
        question: "Jaka była reakcja Feliksa na przesłanie Pawła?",
        options: [
          "Nawrócił się",
          "Zatrwożył się i zadrżał",
          "Wyśmiał",
          "Pozostał obojętny"
        ],
        correctAnswer: 1,
        hint: "Sumienie zaniepokoione prawdą",
        funFact: "😰 Nawet skorumpowani drżą przed prawdą Bożą - uniwersalne sumienie!"
      },
      hard: {
        question: "Dlaczego Feliks trzymał Pawła w więzieniu przez dwa lata?",
        options: [
          "Aby go chronić",
          "Z powodu interesów politycznych i nadziei na korupcję",
          "Zapomniał",
          "Z przekonania"
        ],
        correctAnswer: 1,
        hint: "Chodzi o kalkulacje polityczne i osobiste",
        funFact: "🏛️ Skorumpowana sprawiedliwość ludzka vs doskonała sprawiedliwość Boża - ostry kontrast!"
      }
    },

    81: {
      name: "Odwołanie do Cezara",
      challenge: "Odwołuję się do Cezara!",
      easy: {
        question: "Jakiego prawa użył Paweł, aby uniknąć procesu w Jerozolimie?",
        options: [
          "Prawo azylu",
          "Odwołanie do Cezara (obywatel rzymski)",
          "Prawo ucieczki",
          "Ochrona dyplomatyczna"
        ],
        correctAnswer: 1,
        hint: "Przywilej jego rzymskiego obywatelstwa",
        funFact: "🏛️ Obywatelstwo rzymskie: Boży paszport do zaniesienia Ewangelii do Rzymu!"
      },
      medium: {
        question: "Przed kim Paweł świadczył przed wyjazdem?",
        options: [
          "Sanhedrynem",
          "Królem Agryppą i Bereniką",
          "Rzymskimi żołnierzami",
          "Tłumem żydowskim"
        ],
        correctAnswer: 1,
        hint: "Zjudaizowana królewska rodzina herodiańska",
        funFact: "👑 Od pasterza owiec do królewskiego pałacu - Boża promocja Pawła!"
      },
      hard: {
        question: "Jak Bóg używa ludzkich systemów do swoich planów?",
        options: [
          "Ignoruje je",
          "Używa ich opatrznościowo do realizacji swoich zamiarów",
          "Niszczy je",
          "Zawsze się im sprzeciwia"
        ],
        correctAnswer: 1,
        hint: "Chodzi o Bożą suwerenność nad historią",
        funFact: "🌐 Rzymska sprawiedliwość staje się nośnikiem Ewangelii - niezwykła opatrzność!"
      }
    },

    82: {
      name: "Rozbicie na Malcie",
      challenge: "Nie bój się, Pawle; musisz stanąć przed Cezarem...",
      easy: {
        question: "Na której wyspie Paweł rozbił się?",
        options: ["Kreta", "Cypr", "Malta", "Sycylia"],
        correctAnswer: 2,
        hint: "Mała wyspa na południe od Sycylii",
        funFact: "🏝️ Malta: przymusowy przystanek staje się owocną misją - Boże objazdy!"
      },
      medium: {
        question: "Jaki cud Paweł dokonał na Malcie?",
        options: [
          "Uciszył burzę",
          "Uzdrowił ojca Publiusza i innych chorych",
          "Rozmnożył pożywienie",
          "Wskrzesił umarłego"
        ],
        correctAnswer: 1,
        hint: "Liczne uzdrowienia na wyspie",
        funFact: "🏥 Paweł: od rozbitka do cudotwórczego lekarza - Boża reputacja!"
      },
      hard: {
        question: "Jak to rozbicie ilustruje Bożą wierność?",
        options: [
          "Wypadki się zdarzają",
          "Bóg chroni i spełnia swoje obietnice pomimo przeszkód",
          "Paweł miał szczęście",
          "Dało się tego uniknąć"
        ],
        correctAnswer: 1,
        hint: "Chodzi o Bożą wierność obietnicom",
        funFact: "⛈️ Burza, rozbicie, wąż: nic nie zatrzyma Bożego planu dla Pawła!"
      }
    },

    83: {
      name: "Paweł w Rzymie",
      challenge: "Pozostał całe dwa lata w wynajętym domu...",
      easy: {
        question: "W jakich warunkach Paweł żył w Rzymie?",
        options: [
          "W zamkniętym więzieniu",
          "W areszcie domowym",
          "W całkowitej wolności",
          "Na wygnaniu"
        ],
        correctAnswer: 1,
        hint: "Względna wolność pod nadzorem",
        funFact: "🏠 Dom-więzienie staje się centrum misyjnym - wolność w kajdanach!"
      },
      medium: {
        question: "Co Paweł robił przez dwa lata w Rzymie?",
        options: [
          "Odpoczywał",
          "Nauczał i pisał swoje listy",
          "Przygotowywał obronę",
          "Zwiedzał"
        ],
        correctAnswer: 1,
        hint: "Intensywna służba pomimo kajdan",
        funFact: "✍️ Listy z więzienia: Efezjan, Filipian, Kolosan, Filemona!"
      },
      hard: {
        question: "Jak według tradycji Paweł zakończył swoją służbę?",
        options: [
          "Zmarł z powodu choroby",
          "Został ścięty za Nerona około 67 r. n.e.",
          "Zmarł ze starości",
          "Zniknął tajemniczo"
        ],
        correctAnswer: 1,
        hint: "Męczeństwo za szalonego cesarza",
        funFact: "⚔️ 'Dobry bój bojowałem, bieg ukończyłem' - ostateczne zwycięstwo!"
      }
    },

    84: {
      name: "List do Rzymian",
      challenge: "Nie wstydzę się Ewangelii; jest ona mocą Bożą ku zbawieniu...",
      easy: {
        question: "Który list najbardziej rozwija doktrynę zbawienia przez wiarę?",
        options: ["1 Koryntian", "Galatów", "Rzymian", "Efezjan"],
        correctAnswer: 2,
        hint: "Teologiczna 'katedra' Pawła",
        funFact: "🏛️ Rzymian: arcydzieło teologiczne, które nawróciło Augustyna i Lutra!"
      },
      medium: {
        question: "Według Rzymian, jak człowiek jest usprawiedliwiony przed Bogiem?",
        options: [
          "Przez dobre uczynki",
          "Przez samą wiarę, bez uczynków",
          "Przez ofiary",
          "Przez tradycję"
        ],
        correctAnswer: 1,
        hint: "Podstawowa zasada Reformacji",
        funFact: "⚖️ 'Sprawiedliwy z wiary żyć będzie' - duchowa rewolucja Pawła!"
      },
      hard: {
        question: "Jaki jest uniwersalny zasięg tego listu?",
        options: [
          "Dotyczy tylko Rzymian",
          "Przedstawia plan zbawienia dla całej ludzkości",
          "Krytykuje tylko Rzym",
          "Jest przestarzały"
        ],
        correctAnswer: 1,
        hint: "Chodzi o uniwersalny plan zbawienia",
        funFact: "🌍 Ewangelia = moc Boża dla wszystkich: Żydów i Greków - całkowita uniwersalność!"
      }
    },

    85: {
      name: "Hymn o Miłości - 1 Koryntian 13",
      challenge: "Gdybym mówił językami ludzi i aniołów, a miłości bym nie miał...",
      easy: {
        question: "Który rozdział Biblii nazywany jest 'hymnem o miłości'?",
        options: [
          "1 Koryntian 12",
          "1 Koryntian 13",
          "1 Jana 4",
          "Rzymian 8"
        ],
        correctAnswer: 1,
        hint: "Centralny rozdział 1 Koryntian",
        funFact: "💝 Rozdział najczęściej czytany na ślubach - doskonała definicja miłości!"
      },
      medium: {
        question: "Co Paweł mówi o trwałości miłości?",
        options: [
          "Miłość przemija z czasem",
          "Miłość nigdy nie ustaje",
          "Miłość zależy od okoliczności",
          "Miłość jest tymczasowa"
        ],
        correctAnswer: 1,
        hint: "Wieczność Bożej miłości",
        funFact: "♾️ Tylko miłość przekracza śmierć i wieczność - najwyższa wartość!"
      },
      hard: {
        question: "Dlaczego Paweł stawia miłość ponad darami duchowymi?",
        options: [
          "Dary są złe",
          "Miłość nadaje sens i wartość wszystkiemu innemu",
          "Miłość jest łatwiejsza",
          "Dary dzielą"
        ],
        correctAnswer: 1,
        hint: "Chodzi o motor i sens wszelkiej służby",
        funFact: "🎯 Bez miłości nawet największe dary stają się hałasem i pychą!"
      }
    },

    86: {
      name: "Efezjan: Kościół Ciałem Chrystusa",
      challenge: "Wszystko poddał pod Jego stopy i ustanowił Go głową Kościoła...",
      easy: {
        question: "Według Efezjan, czym jest Kościół w relacji do Chrystusa?",
        options: [
          "Jego świątynią",
          "Jego ciałem",
          "Jego rodziną",
          "Jego armią"
        ],
        correctAnswer: 1,
        hint: "Organiczna metafora jedności",
        funFact: "👤 Ciało Chrystusa: każdy chrześcijanin jest niezbędnym członkiem - współzależność!"
      },
      medium: {
        question: "Jaką zbroje opisuje Paweł do walki duchowej?",
        options: [
          "Zbroję fizyczną",
          "Zbroję Bożą: prawda, sprawiedliwość, pokój, wiara, zbawienie, Słowo",
          "Zbroję rzymską",
          "Ochronę magiczną"
        ],
        correctAnswer: 1,
        hint: "Sześć elementów duchowej zbroi",
        funFact: "⚔️ Walka duchowa duchową bronią - Boża strategia zwycięstwa!"
      },
      hard: {
        question: "Przeciw komu według Pawła jest nasza prawdziwa walka?",
        options: [
          "Przeciw złym ludziom",
          "Przeciw duchowym mocą zła",
          "Przeciw rządom",
          "Przeciw ubóstwu"
        ],
        correctAnswer: 1,
        hint: "Chodzi o niewidzialne siły duchowe",
        funFact: "👹 Kosmiczna walka: za ludzkimi konfliktami prawdziwa wojna duchowa!"
      }
    },

    87: {
      name: "Filipian: Radość w Próbie",
      challenge: "Radujcie się zawsze w Panu; jeszcze raz powiem: radujcie się!",
      easy: {
        question: "Jakie uczucie Paweł zachęca pomimo swojego więzienia?",
        options: ["Rezygnacja", "Radość", "Gniew", "Smutek"],
        correctAnswer: 1,
        hint: "Zaskakująca emocja dla więźnia",
        funFact: "😊 Radość 16 razy w 4 rozdziałach - rekord szczęścia w więzieniu!"
      },
      medium: {
        question: "Według Filipian 2, jaką postawę przyjął Jezus?",
        options: [
          "Narzucił się siłą",
          "Uniżył się i upokorzył aż do śmierci",
          "Uciekł od odpowiedzialności",
          "Szukał chwały"
        ],
        correctAnswer: 1,
        hint: "Dobrowolny ruch w dół",
        funFact: "📉 Jezus: od równości z Bogiem do śmierci krzyżowej - ekstremalna miłość!"
      },
      hard: {
        question: "Jak Paweł może głosić radość w więzieniu?",
        options: [
          "Udaje",
          "Chrześcijańska radość transcenduje okoliczności",
          "Jest masochistą",
          "Zaprzecza rzeczywistości"
        ],
        correctAnswer: 1,
        hint: "Chodzi o nadprzyrodzoną radość",
        funFact: "✨ Radość = owoc Ducha niezależny od okoliczności - Boży sekret!"
      }
    },

    88: {
      name: "Listy Pasterskie",
      challenge: "Toczysz dobry bój wiary, zdobądź życie wieczne...",
      easy: {
        question: "Do kogo Paweł napisał swoje ostatnie listy pasterskie?",
        options: [
          "Do Koryntian",
          "Do Tymoteusza i Tytusa",
          "Do Rzymian",
          "Do Galatów"
        ],
        correctAnswer: 1,
        hint: "Jego duchowi synowie i współpracownicy",
        funFact: "👨‍👦 Duchowy testament: Paweł przekazuje pochodnię następnemu pokoleniu!"
      },
      medium: {
        question: "Jaką radę daje Paweł dotyczącą wyboru przywódców kościoła?",
        options: [
          "Wybierać najbogatszych",
          "Wybierać według rygorystycznych kryteriów moralnych i duchowych",
          "Wybierać najbardziej wykształconych",
          "Wybierać najpopularniejszych"
        ],
        correctAnswer: 1,
        hint: "Kwalifikacje moralne przede wszystkim",
        funFact: "⚖️ Wysokie standardy dla przywódców: charakter przed kompetencjami - Boże priorytety!"
      },
      hard: {
        question: "Jakie dziedzictwo Paweł zostawia Tymoteuszowi?",
        options: [
          "Dobra materialne",
          "Wierność Ewangelii i służbę pasterską",
          "Stanowisko polityczne",
          "Szkołę teologiczną"
        ],
        correctAnswer: 1,
        hint: "Chodzi o duchowe dziedzictwo",
        funFact: "📜 'Strzeż dobrego depozytu' - wierne przekazywanie Ewangelii przez wieki!"
      }
    },

    89: {
      name: "Hebrajczyków: Jezus Arcykapłan",
      challenge: "Mamy wielkiego arcykapłana, który przeszedł przez niebiosa...",
      easy: {
        question: "Według Hebrajczyków, kto jest naszym wielkim arcykapłanem?",
        options: ["Aaron", "Mojżesz", "Jezus", "Melchizedek"],
        correctAnswer: 2,
        hint: "Doskonały pośrednik między Bogiem a ludźmi",
        funFact: "✝️ Jezus: Kapłan i Ofiara - doskonała ofiara raz na zawsze!"
      },
      medium: {
        question: "Dlaczego kapłaństwo Jezusa jest wyższe niż Aarona?",
        options: [
          "Jest starsze",
          "Jest wieczne według porządku Melchizedeka",
          "Jest bogatsze",
          "Jest popularniejsze"
        ],
        correctAnswer: 1,
        hint: "Wieczność vs czasowość",
        funFact: "♾️ Wieczne kapłaństwo: Jezus wstawia się za nami na wieki!"
      },
      hard: {
        question: "Jak Hebrajczyków przedstawia Nowe Przymierze?",
        options: [
          "Identyczne ze starym",
          "Lepsze i ostateczne, zapisane w sercach",
          "Tymczasowe",
          "Opcjonalne"
        ],
        correctAnswer: 1,
        hint: "Chodzi o wypełnienie i przekroczenie",
        funFact: "📋 Nowe Przymierze: prawo zapisane w sercach, nie na kamieniu!"
      }
    },

    90: {
      name: "Jakub: Wiara i Uczynki",
      challenge: "Wiara bez uczynków jest martwa...",
      easy: {
        question: "Według Jakuba, co powinno towarzyszyć wierze?",
        options: [
          "Słowa",
          "Uczynki",
          "Emocje",
          "Wiedza"
        ],
        correctAnswer: 1,
        hint: "Praktyczny wyraz wiary",
        funFact: "🌳 Wiara = korzeń, uczynki = owoce - kompletne duchowe drzewo!"
      },
      medium: {
        question: "Do czego Jakub porównuje język?",
        options: [
          "Do miecza",
          "Do małego ognia, który podpala wielki las",
          "Do instrumentu muzycznego",
          "Do narzędzia"
        ],
        correctAnswer: 1,
        hint: "Mały członek, ale wielka destrukcyjna moc",
        funFact: "🔥 Język: mały członek, ale może spalić całe życie - ostrożność!"
      },
      hard: {
        question: "Jak pogodzić Jakuba i Pawła w kwestii wiara/uczynki?",
        options: [
          "Sprzeczne",
          "Paweł mówi o usprawiedliwieniu, Jakub o uświęceniu",
          "Jeden się myli",
          "Nie ma rozwiązania"
        ],
        correctAnswer: 1,
        hint: "Chodzi o dwa uzupełniające się aspekty",
        funFact: "⚖️ Paweł: zbawieni przez wiarę / Jakub: wiara udowodniona uczynkami - doskonała harmonia!"
      }
    },

    91: {
      name: "Apokalipsa: Powrót Króla",
      challenge: "Oto przyjdę niebawem. Błogosławiony, kto strzeże słów proroctwa tej księgi!",
      easy: {
        question: "Do ilu kościołów Jan pisze w Apokalipsie?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "Liczba doskonałości",
        funFact: "⛪ 7 kościołów Azji: zwierciadło wszystkich kościołów wszystkich czasów!"
      },
      medium: {
        question: "Jak według Apokalipsy kończy się historia?",
        options: [
          "Całkowite zniszczenie",
          "Nowe niebo i nowa ziemia",
          "Powrót do raju ziemskiego",
          "Koniec wszelkiego istnienia"
        ],
        correctAnswer: 1,
        hint: "Całkowite odnowienie stworzenia",
        funFact: "🌅 Nie koniec świata, ale całkowite odnowienie - ostateczna nadzieja!"
      },
      hard: {
        question: "Jakie centralne przesłanie Apokalipsa przekazuje prześladowanym?",
        options: [
          "Poddajcie się",
          "Chrystus panuje i ostatecznie zwycięży",
          "Uciekajcie od prześladowania",
          "Mścijcie się"
        ],
        correctAnswer: 1,
        hint: "Chodzi o nadzieję na ostateczne zwycięstwo",
        funFact: "👑 'Który był, który jest i który przyjdzie' - Pan historii i czasu!"
      }
    }
  }
};

export default chapter7Translations;
